import { jsx } from "react/jsx-runtime";
import {
  Field,
  __css,
  mergeClasses,
  tokens
} from "@fluentui/react-components";
const useStyles = __css({"vertical":{"Budl1dq":"fgx874q"},"label":{"Be2twd7":"fanxd30","Bg96gwp":"f1n95isl","Bhrd7zp":"fdj6btp","sj55zd":"f19n0e5"},"hint":{"Be2twd7":"f1ugzwwg","Bg96gwp":"f104wqfl","sj55zd":"f11d4kpn"},"error":{"Be2twd7":"f1ugzwwg","Bg96gwp":"f104wqfl","sj55zd":"f1hcrxcs"}});
function findFieldError(errors, path) {
  return errors?.find((e) => e.path === path);
}
function fieldErrorText(error) {
  if (!error) return "";
  return typeof error === "string" ? error : error.message;
}
function FormField({
  label,
  hint,
  error,
  required,
  orientation,
  className,
  children
}) {
  const styles = useStyles();
  const message = fieldErrorText(error);
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses(
        orientation === "horizontal" ? void 0 : styles.vertical,
        className
      ),
      required: required ?? false,
      ...orientation ? { orientation } : {},
      ...label ? { label: { children: label, className: styles.label } } : {},
      ...hint ? { hint: { children: hint, className: styles.hint } } : {},
      ...message ? {
        validationState: "error",
        validationMessage: { children: message, className: styles.error }
      } : {},
      children
    }
  );
}
export {
  FormField,
  fieldErrorText,
  findFieldError
};
//# sourceMappingURL=form-field.js.map

import "/opt/batiflow/app/packages/ui/dist/components/form-field/form-field.griffel.css";